import { BasicButton, SimpleLabledInput } from '../components'
import { IoChevronDownCircleSharp } from 'react-icons/io5'
import { useState } from 'react'
import { v4 as uuidv4 } from 'uuid';
import INPUTTYPES from '../../application/utils/InputTypes';
import services from '../../ioc/services';
import ModalContainer from './ModalContainer'
import Lottie from 'lottie-react';
import animation from '../../application/assets/animations/pencil-drawing-animation.json'

function AddFormControl({ setFormFields, saveFormFunction, isUpdate = false }) {

    const [isControlOpen, setControlOpen] = useState(false);

    const [isGenerateDialogOpen, setIsGenerateDialogOpen] = useState(false);

    const [generateData, setGenerateData] = useState({});

    const [isGeneratingForm, setIsGeneratingForm] = useState(false);

    const generateMessages = ["Submitting", "Generating questions", "Optimizing Questions", "Formatting Questions", "Assesmbling"]

    const [currentMessage, setCurrentMessage] = useState(0)

    const [messageInterval, setMessageInterval] = useState(null);

    const toggleControlChange = () => {
        setControlOpen(!isControlOpen);
    }

    const addInputField = (field, key) => {

        setFormFields(ld => [...ld, {
            id: uuidv4(),
            key,
            type: field.name,
            isExpanded: true,
            validations: {}
        }])

        setControlOpen(!isControlOpen);
    }

    const handleGenerateDataOption = (name, value) => {
        let data = {};
        data[name] = value;
        setGenerateData(dt => ({ ...dt, ...data }))
    }

    const handleModalClose = (closeManually = false) => {

        setCurrentMessage(0);
        setIsGeneratingForm(false)
        setGenerateData({});

        if (messageInterval != null) {
            clearInterval(messageInterval);
        }

        if (closeManually) {
            setIsGenerateDialogOpen(false);
        }

    }

    const generateForm = () => {

        setIsGeneratingForm(true)

        setMessageInterval(setInterval(() => {

            setCurrentMessage(cm => cm + 1 < generateMessages.length ? cm + 1 : 2)

        }, 2000))

        services.api.form.generateForm(generateData)
            .then(res => {
                services.alert.toast.success("Form Generated Successfully");
                handleModalClose(true);
                setFormFields(res)
            })
            .catch(err => {
                services.alert.toast.error(err)
                handleModalClose()
            })


    }

    return (
        <>
            <div className="relative z-50">
                {!isUpdate && <div className="flex justify-between items-center">
                    <div className="flex gap-5 text-lg tracking-widest">
                        <button className="flex items-center gap-1" onClick={toggleControlChange} >New Field <IoChevronDownCircleSharp /> </button>
                        <button>Clear</button>
                    </div>

                    <div className='grid grid-cols-2 gap-2 text-sm'>

                        <div>
                            <BasicButton onClick={() => setIsGenerateDialogOpen(true)} text="Generate Form" />
                        </div>
                        <div>
                            <BasicButton onClick={saveFormFunction} text="Save Form" />
                        </div>
                    </div>
                </div>}

                {isUpdate && <div className="flex justify-between items-center">
                    <div className="flex gap-5 text-sm">
                        <p className=' bg-red-50 p-2 border border-red-500 rounded-md italic '>
                            To manage responses, changes to a form is limited. You cannot add new fields to a form with responses.
                        </p>
                    </div>

                    <div>
                        <BasicButton onClick={saveFormFunction} text="Update Form" />
                    </div>
                </div>}

                <div className={` ${isControlOpen ? 'block' : 'hidden'}  absolute bg-white shadow-md p-4`}>
                    <div className="grid grid-cols-3 gap-3">

                        {Object.keys(INPUTTYPES).map(inputName => <span
                            className="cursor-pointer flex gap-3 items-center hover:bg-slate-100 p-3 rounded-md"
                            onClick={() => addInputField(INPUTTYPES[inputName], inputName)}>
                            {INPUTTYPES[inputName].icon}
                            {INPUTTYPES[inputName].name}
                        </span>)}

                    </div>

                </div>
            </div>

            <ModalContainer title="Generate Form Questions" isOpen={isGenerateDialogOpen} setIsOpen={setIsGenerateDialogOpen} runBeforeClose={handleModalClose
            }>

                <div className='h-full'>
                    <p className=' text-center text-sm italic'>We have enhanced UFarmX with the addition of AI integration, enabling automated question generation</p>

                    <div className='flex flex-col gap-6 my-4 p-6 mx-auto max-w-xl'>
                        <SimpleLabledInput
                            label="Enter the aim for the form"
                            name="formAim"
                            placeholder="A form to address drought on farm"
                            onChange={e => handleGenerateDataOption('formAim', e.target.value)} />

                        <SimpleLabledInput
                            label="Enter number of Question(Maximum of 15)"
                            name="numberOfQuestions"
                            type="number"
                            max="15"
                            min="1"
                            onChange={e => handleGenerateDataOption('numberOfQuestions', e.target.value)}
                        />

                        {!isGeneratingForm && <BasicButton onClick={generateForm} text="Generate Form" />}
                        {isGeneratingForm &&
                            <div className=' h-40'>
                                <Lottie animationData={animation} loop={true} className="h-full" />
                                <p className=' text-xs italic text-center mt-2'>
                                    {generateMessages[currentMessage]}....
                                </p>
                            </div>
                        }
                    </div>

                </div>

            </ModalContainer>
        </>
    )
}

export default AddFormControl


// <div className="z-50 w-2/3 h-56 bg-white rounded-lg flex  items-center justify-end p-4">
                            //     <Lottie source={require('../../application/assets/animations/cycling-animation.json')} autoPlay loop />
                            // </div>